import axios from 'axios';
import {
    APPLICATION_LOCAL_STORAGE,
    REDIRECTION_PAGE,
    STATUS_CODE,
    AUTH_TOKEN_GENERATION_TIME_IN_SEC
} from './common/constants/constants';
import { getEnv } from './enviroment';

const { base } = getEnv();

const generateAuthTokenByRefreshToken = async () => {
    
    try {
        const storedrefreshToken = localStorage.getItem(
            APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN
        );
        if (storedrefreshToken !== null && window?.location?.pathname !== REDIRECTION_PAGE?.LOGIN_PAGE) {
            const loginTimestamp = localStorage.getItem(
                APPLICATION_LOCAL_STORAGE.TOKEN_TIME_STAMP
            );
            const sessionTimeoutInMilliseconds = localStorage.getItem(
                APPLICATION_LOCAL_STORAGE.SESSION_TIMEOUT_IN_MILLI_SECONDS
            );

            if (!loginTimestamp || !sessionTimeoutInMilliseconds) {
                console.error("Missing login timestamp or session timeout.");
                redirect();
                return;
            }

            const capTime = parseInt(sessionTimeoutInMilliseconds) - 120000;
            const buffTime = parseInt(loginTimestamp) + capTime;
            const currentTimestamp = Date.now();

            if (currentTimestamp >= buffTime) {
                const payload = {
                    refreshToken: storedrefreshToken,
                };

                try {
                    const res = await axios.post(`${base}/generate/authToken`, payload, {
                     
                        headers: {
                       'x-authtoken': `${localStorage.getItem(APPLICATION_LOCAL_STORAGE.AUTH_TOKEN)}`, 
                       'Authorization': `${localStorage.getItem(APPLICATION_LOCAL_STORAGE.AUTH_TOKEN)}`, 
                       'Content-Type': 'application/json'
                        },
                    });

                    if (res?.status === STATUS_CODE.OK && res?.data?.authToken) {
                        localStorage.setItem(
                            APPLICATION_LOCAL_STORAGE.AUTH_TOKEN,
                            res.data.authToken
                        );
                        const currentTimeStamp = Date.now();
                        localStorage.setItem(
                            APPLICATION_LOCAL_STORAGE.TOKEN_TIME_STAMP,
                            currentTimeStamp
                        );
                        const localTimeStr = new Date(currentTimeStamp).toLocaleTimeString(
                            'en-US'
                        );
                        localStorage.setItem(
                            APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN_LAST_UPDATED_AT,
                            localTimeStr
                        );
                    } else {
                        console.error("Token refresh failed:", res?.data);
                        redirect();
                    }
                } catch (apiError) {
                    console.error("API error during token refresh:", apiError);
                    redirect();
                }
            }
        }
    } catch (err) {
        console.error("Error during token refresh process:", err);
        redirect();
    }
};

setInterval(generateAuthTokenByRefreshToken, AUTH_TOKEN_GENERATION_TIME_IN_SEC );

const redirect = () => {
    localStorage.clear();
    window.location.replace(REDIRECTION_PAGE.LOGIN_PAGE);
    console.log('Redirect to Login page for Web.');
};